import React, { useRef, useState, useEffect } from 'react';
import Select from 'react-select';
import { connect } from 'react-redux';
import * as cafeActions from '../../../redux/cafes/actions';
import ENUMS from '../../../enums';
import styles from './styles.scss';
import DatePicker from './../../../components/FormElements/DatePicker/DatePicker';
import { Tooltip } from 'reactstrap';
import InputBase from '../../../components/input-base/input-base';

const CafeListFilter = props => {
  let formRefrence = useRef();
  let { applyFilters, onSelectRegions, selectedAmenities } = props;
  let [btnClicked, setBtnClicked] = useState('');
  let [amenities, setAmenities] = useState([]);
  let [selectedStatusCheckbox, setSelectedStatusCheckbox] = useState([]);
  let [regionsChecked, setSelectedRegions] = useState([]);
  let [selectedAmenitiesCheckbox, setSelectedAmenitiesCheckbox] = useState([]);
  let [specialServices, setSpecialServices] = useState([]);
  let [startDate, setStartDate] = useState(' ');
  let [name, setName] = useState('');
  let [endDate, setEndDate] = useState(' ');
  const [isBest, setIsBest] = useState('null');
  const [hasEvent, setHasEvent] = useState('null');
  const [hasDiscount, setHasDiscount] = useState('null');
  const [error, setError] = useState();
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const [cafeType, setCafeType] = useState('')

  const toggle = () => setTooltipOpen(!tooltipOpen);

  useEffect(() => {
    // props.getRegions();
    props.getAmenities().then(res => {
      for (let i = 0; i < res.payload.length; i++)
        amenities.push({
          value: res.payload[i].id,
          label: res.payload[i].name
        });
      setAmenities([...amenities]);
    });
    props.getSpecialServices().then(res => {
      for (let i = 0; i < res.payload.length; i++)
        specialServices.push({
          value: res.payload[i].id,
          label: res.payload[i].name
        });
      setSpecialServices([...specialServices]);
    });
  }, []);

  function handleEndDataChange(v) {
    if (startDate > v) {
      console.log(startDate, endDate, 'if');
      setError('مقدار وارد شده کوچکتر از تاریخ شروع می باشد');
      setEndDate(' ');
    } else {
      console.log(startDate, endDate, 'else');
      setError();
      setEndDate(v);
    }
  }

  const resetForm = event => {
    Array.from(formRefrence.current).forEach(element => {
      if (element.type === 'radio' || element.type === 'checkbox') {
        element.checked = null;
      } else if (element.name === 'resetButton') {
        element.value = locales('fields.reset');
      } else {
        element.value = null;
      }
    });
    onSelectRegions([]);
    setSelectedRegions([]);
    setSelectedStatusCheckbox(null);
    setSelectedAmenitiesCheckbox(null);
    setHasEvent('null');
    setHasDiscount('null');
    setIsBest('null');
    setStartDate(' ');
    setEndDate(' ');
    selectedAmenities([]);
    setName('');
    setCafeType('');
    props.applyFilters(event);
  };

  return (
    <article>
      <form
        onReset={event => resetForm(event)}
        onSubmit={event => applyFilters(event, btnClicked)}
        id="form"
        ref={formRefrence}
        className="my-4"
      >
        <main className="card-body">
          <div className="col-12 d-flex justify-content-between">
            <div className="col-4 d-flex">
              <label className="rsee-form-label col-3 text-right filter-field-label">{locales('fields.cafe.name')}</label>
              <div className='full-width'>
                <input
                  name="name"
                  type="text"
                  value={name}
                  onChange={event => setName(event.target.value)}
                  className="form-control col-12"
                  placeholder={locales('fields.cafe.name')}
                  maxLength={ENUMS.MAX_LENGTH.cafeName}
                  id="cafeNameInput"
                />
                <Tooltip placement="top-start" isOpen={tooltipOpen} target="cafeNameInput" toggle={toggle}>
                  {locales('maxLength.50')}
                </Tooltip>
                {/* <InputBase
                name="name"
                type="text"
                value={name}
                onChange={event => setName(event.target.value)}
                placeholder={locales('fields.cafe.name')}
                maxLength={ENUMS.MAX_LENGTH.cafeName}
                id="cafeNameInput"
              /> */}
              </div>
            </div>
            <div className="col-4 d-flex">
              <label className="rsee-form-label col-3 text-right filter-field-label">{locales('messages.regions')}</label>
              <div className='full-width'>
                {/* <Select
                  id="regionIds"
                  name="regionIds"
                  isMulti={true}
                  value={regionsChecked}
                  onChange={selectedRegionIds => {
                    setSelectedRegions(selectedRegionIds);
                    onSelectRegions(selectedRegionIds);
                  }}
                  className="col-12"
                  options={props.regions.map(region => ({
                    label: region.name,
                    value: region.id
                  }))}
                  placeholder={locales('messages.selectRegion')}
                /> */}
              </div>
            </div>
            <div className="col-4 d-flex">
              <label className="rsee-form-label col-3 text-right filter-field-label">{locales('messages.facilities')}</label>
              <div className="full-width">
                <Select
                  id="amenities"
                  name="amenities"
                  isMulti={true}
                  value={selectedAmenitiesCheckbox}
                  onChange={chosenAmenities => {
                    selectedAmenities(chosenAmenities);
                    setSelectedAmenitiesCheckbox(chosenAmenities);
                  }}
                  options={props.amenities.map(amenity => ({
                    label: amenity.name,
                    value: amenity.id
                  }))}
                  placeholder={locales('messages.selectAmenities')}
                />
              </div>
            </div>
          </div>

          <div className="col-12 d-flex flex-wrap justify-content-between py-3">
            <div className="d-flex col-8 col-md-7 align-items-center">
              <label className="rsee-form-label col-2 text-right filter-field-label">{locales('tables.creationDate')}</label>
              <div className="d-flex col-12 justify-content-around py-2 align-items-center">
                از
                <DatePicker
                  marge={true}
                  placeholder="تاریخ شروع"
                  name="startDate"
                  className="form-control"
                  value={startDate}
                  onChange={v => setStartDate(v)}
                />
                تا
                <DatePicker
                  marge={true}
                  placeholder="تاریخ پایان"
                  name="endDate"
                  className="form-control"
                  value={endDate}
                  onChange={v => handleEndDataChange(v)}
                />
              </div>
              {error && <div style={{ color: 'red', fontSize: '0.8rem' }}>{error}</div>}
            </div>
            <div className="d-flex col-4 justify-content-around py-2 align-items-center">
              <label
                className="rsee-form-label col-3 text-right filter-field-label"
                htmlFor="cafeType"
              >
                {locales('cafes.type')}
              </label>
              <div className="full-width">
                <Select
                  placeholder={locales('messages.select.cafes.type')}
                  isMulti={false}
                  value={cafeType}
                  id="cafeType"
                  name="cafeType"
                  options={ENUMS.CAFE_TYPE.list?.map(type => ({
                    value: type.value,
                    label: type.title,
                  }))}
                  onChange={selected =>
                    setCafeType(selected)
                  }
                />
              </div>
            </div>
          </div>

          <div className="col-12 d-flex justify-content-around py-2 align-items-center">
            <label className="col-3 p-0 text-right filter-field-label">{locales('tables.status')}</label>
            <div className="d-flex justify-content-around mx-1 py-2 col-9">
              <div className="col-12 p-0 d-flex justify-content-start align-items-center">
                {ENUMS.CAFE_STATUS.list.map((cafeStatus, index) => (
                  <div className={`col-4 d-flex justify-content-start align-items-center p-0`} key={index}>
                    <input
                      type="checkbox"
                      value={cafeStatus.value}
                      name={`status`}
                      id={`status-${index}`}
                      className=""
                      maxLength="10"
                    />
                    <label className="mx-1 text-center my-2 p-0" htmlFor={`status-${index}`}>
                      {cafeStatus.title}
                    </label>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className="d-flex justidy-content-around px-1 my-3">
            <div className="col-3">
              <span className="col-2 text-center filter-field-label">{locales('titles.discount')}</span>
              <select
                name="hasDiscount"
                id="hasDiscount"
                className={styles.switchWithDropDown}
                value={hasDiscount}
                onChange={e => setHasDiscount(e.target.value)}
              >
                <option value="null">{locales('labels.both')}</option>
                <option value="true">{locales('labesl.with.discount')}</option>
                <option value="false">{locales('labesl.without.discount')}</option>
              </select>
            </div>

            <div className="col-3">
              <span className="col-2 text-center filter-field-label">{locales('titles.event')}</span>
              <select
                name="hasEvent"
                id="hasEvent"
                className={styles.switchWithDropDown}
                value={hasEvent}
                onChange={e => setHasEvent(e.target.value)}
              >
                <option value="null">{locales('labels.both')}</option>
                <option value="true">{locales('labesl.with.event')}</option>
                <option value="false">{locales('labesl.without.event')}</option>
              </select>
            </div>
            <div className="col-3">
              <span className="col-2 text-center filter-field-label">{locales('titles.best')}</span>
              <select
                name="isBest"
                id="isBest"
                className={styles.switchWithDropDown}
                value={isBest}
                onChange={e => setIsBest(e.target.value)}
              >
                <option value="null">{locales('labels.both')}</option>
                <option value="true">{locales('labesl.in.bests')}</option>
                <option value="false">{locales('labesl.not.in.bests')}</option>
              </select>
            </div>
          </div>

          <div className="col-12 d-flex justify-content-end p-0">
            <input
              name="resetButton"
              type="reset"
              value={locales('fields.reset')}
              className="btn btn-danger w-5 mx-2"
              maxLength="10"
            />
            <button
              type="submit"
              id="apply-filter-btn-cafe"
              className="btn btn-success w-5 mx-2"
              name="filter"
              onClick={() => setBtnClicked('filter')}
            >
              {locales('fields.applyFilters')}
            </button>
          </div>
        </main>
      </form>
    </article>
  );
};

const mapStateToProps = state => {
  const {
    amenities,
    specialServices,
    // regions,
    getAmenitiesLoading,
    getRegionsLoading,
    getSpecialServicesLoading
  } = state.cafesReducer;

  return {
    amenities,
    specialServices,
    // regions,
    getAmenitiesLoading,
    getRegionsLoading,
    getSpecialServicesLoading
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getAmenities: () => dispatch(cafeActions.getAmenities()),
    // getRegions: () => dispatch(cafeActions.getRegions()),
    getSpecialServices: () => dispatch(cafeActions.getSpecialServices())
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CafeListFilter);
